/**
 * The canonical origin for the public blog.
 *
 * playanoedu.com 301s to www.playanoedu.com, so every canonical, Open Graph and
 * JSON-LD URL must name the www host — otherwise search engines are pointed at
 * a redirect and the two hosts compete for the same post.
 */
export const SITE_ORIGIN = 'https://www.playanoedu.com';
